// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3E%3Cpath fill=%27%23333%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Firefox compatibility fixes */

/* Remove webkit-specific properties that Firefox doesn't need */
* {
  -webkit-text-size-adjust: none !important;
}

/* Firefox font smoothing */
body {
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

/* Fix for Firefox focus styles */
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

/* Firefox placeholder styles */
input::-moz-placeholder,
textarea::-moz-placeholder {
  opacity: 1;
  color: #999;
}

/* Firefox column gap support */
.row {
  column-gap: var(--bs-gutter-x, 1.5rem);
  -moz-column-gap: var(--bs-gutter-x, 1.5rem);
}

/* Firefox scrollbar styles */
* {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

/* Firefox specific form control fixes */
@-moz-document url-prefix() {
  /* Firefox-specific styles */
  select {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right .75rem center;
    background-size: 8px 10px;
  }
  
  /* Fix for Firefox input height */
  input[type="text"],
  input[type="email"],
  input[type="password"],
  input[type="number"] {
    line-height: normal;
  }
  
  /* Firefox button alignment fix */
  button {
    text-align: center;
  }
}

/* Prevent Firefox from showing dotted outline on focused links */
a:focus {
  outline: none;
}

/* Firefox flexbox fixes */
.d-flex {
  display: flex;
}

/* WebSocket connection fix for development */
@supports (-moz-appearance: none) {
  /* Firefox-specific WebSocket handling */
  /* This is handled by CSP, but we ensure no blocking styles */
}`, "",{"version":3,"sources":["webpack://./src/styles/firefox-fixes.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC,gEAAgE;AAChE;EACE,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,wCAAwC;AACxC;EACE,4BAA4B;EAC5B;IACE,yDAAqL;IACrL,4BAA4B;IAC5B,wCAAwC;IACxC,yBAAyB;EAC3B;;EAEA,iCAAiC;EACjC;;;;IAIE,mBAAmB;EACrB;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;EACpB;AACF;;AAEA,iEAAiE;AACjE;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EAEE,aAAa;AACf;;AAEA,6CAA6C;AAC7C;EACE,wCAAwC;EACxC,6DAA6D;AAC/D","sourcesContent":["/* Firefox compatibility fixes */\n\n/* Remove webkit-specific properties that Firefox doesn't need */\n* {\n  -webkit-text-size-adjust: none !important;\n}\n\n/* Firefox font smoothing */\nbody {\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n}\n\n/* Fix for Firefox focus styles */\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n\n/* Firefox placeholder styles */\ninput::-moz-placeholder,\ntextarea::-moz-placeholder {\n  opacity: 1;\n  color: #999;\n}\n\n/* Firefox column gap support */\n.row {\n  column-gap: var(--bs-gutter-x, 1.5rem);\n  -moz-column-gap: var(--bs-gutter-x, 1.5rem);\n}\n\n/* Firefox scrollbar styles */\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #888 #f1f1f1;\n}\n\n/* Firefox specific form control fixes */\n@-moz-document url-prefix() {\n  /* Firefox-specific styles */\n  select {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23333' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right .75rem center;\n    background-size: 8px 10px;\n  }\n  \n  /* Fix for Firefox input height */\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"password\"],\n  input[type=\"number\"] {\n    line-height: normal;\n  }\n  \n  /* Firefox button alignment fix */\n  button {\n    text-align: center;\n  }\n}\n\n/* Prevent Firefox from showing dotted outline on focused links */\na:focus {\n  outline: none;\n}\n\n/* Firefox flexbox fixes */\n.d-flex {\n  display: -moz-box;\n  display: flex;\n}\n\n/* WebSocket connection fix for development */\n@supports (-moz-appearance: none) {\n  /* Firefox-specific WebSocket handling */\n  /* This is handled by CSP, but we ensure no blocking styles */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
